var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95536 0 0 8.95536 0 20C0 31.0446 8.95536 40 20 40C31.0446 40 40 31.0446 40 20C40 8.95536 31.0446 0 20 0ZM31.4286 11.3259L29.6071 13.0714C29.4464 13.192 29.3705 13.3884 29.4018 13.5804V26.4241C29.3705 26.6205 29.4464 26.817 29.6071 26.933L31.3929 28.6786V29.067H22.4286V28.6964L24.2723 26.9063C24.4554 26.7232 24.4554 26.6696 24.4554 26.3973V16.0045L19.3214 29.0223H18.6295L12.6563 16.0045V24.7321C12.6027 25.0982 12.7321 25.4688 12.9911 25.7321L15.3929 28.6384V29.0268H8.57143V28.6384L10.9732 25.7321C11.0998 25.6014 11.1939 25.4429 11.2482 25.2692C11.3025 25.0956 11.3153 24.9117 11.2857 24.7321V14.6429C11.317 14.3616 11.2098 14.0893 10.9955 13.8973L8.86161 11.3259V10.9375H15.4911L20.6071 22.1652L25.1116 10.9464H31.4286V11.3259Z",
    fill: "url(#paint0_linear_944_335)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_335",
    x1: 40,
    y1: 19.6364,
    x2: -2.34274e-7,
    y2: 19.6364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505591,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon3);
export default __webpack_public_path__ + "static/media/footer_icon_3.c2ef261a9da47be2e423ec1648ed7447.svg";
export { ForwardRef as ReactComponent };